import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Project } from '../services/projectService';
import styles from './ProjectCard.module.css';
import ProgressBar from './ProgressBar';

interface ProjectCardProps {
  project: Project;
  onAnalyze: (projectId: number) => Promise<void>;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, onAnalyze }) => {
  const navigate = useNavigate();
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const formattedDate = new Date(project.creation_date).toLocaleDateString();

  const handleViewDetails = () => {
    navigate(`/projects/${project.id}`);
  };
  
  const handleAnalyzeClick = async () => {
    setIsAnalyzing(true);
    await onAnalyze(project.id);
    // The parent component handles the final state, but we'll keep this button disabled.
    // The isAnalyzing state will reset if the component re-renders due to parent state change.
  };

  return (
    <div className={styles['project-card']}>
      <div className={styles['card-header']}>
        <h3>{project.name}</h3>
        <span className={`${styles['status-badge']} ${styles[`status-${project.state.toLowerCase().replace(/ /g, '-')}`]}`}>
          {project.state}
        </span>
      </div>
      <div className={styles['card-created']}>Creado el {formattedDate}</div>
      <div className={styles['card-body']}>

        {project.state === 'analyzing' && project.stats && (
          <ProgressBar 
            total={project.stats.total}
            completed={project.stats.completed}
            analyzing={project.stats.analyzing}
            failed={project.stats.failed}
          />
        )}
      </div>
      <div className={styles['card-footer']}>
        <button className={styles['view-button']} onClick={handleViewDetails}>Ver Detalles</button>
        <button 
          className={styles['analyze-button']} 
          onClick={handleAnalyzeClick}
          disabled={project.state !== 'Pendiente' || isAnalyzing}
        >
          {isAnalyzing ? 'Iniciando...' : 'Analizar'}
        </button>
      </div>
    </div>
  );
};

export default ProjectCard; 